export const backendUrl = process.env.REACT_APP_BACKEND_URL?.trim() || 'http://localhost:3001';
const cleanBase = backendUrl.replace(/\/$/, '');
export const getBackendUrl = () => cleanBase;

export const loginUrl = `${cleanBase}/api/auth/email-login`;
export const signupUrl = `${cleanBase}/api/auth/signup`;
export const preregisterUrl = `${cleanBase}/api/preregister`;
export const queueUrl = `${cleanBase}/api/queues`;
export const processQueueUrl = (queueId) => `${cleanBase}/api/queues/${queueId}/process`;
export const jobUrl = (jobId) => `${cleanBase}/api/jobs/${jobId}`;
export const jobEventsUrl = (jobId) => `${cleanBase}/api/jobs/${jobId}/events`;
export const userQueuesUrl = (userId) => `${cleanBase}/api/users/${userId}/queues`;
export const userApiBaseUrl = (userId) => `${cleanBase}/api/users/${encodeURIComponent(userId)}`;
export const contextSearchUrl = (userId) => `${userApiBaseUrl(userId)}/context-search`;
export const reviewAnswersUrl = (queueId) => `${cleanBase}/api/queues/${queueId}/review-answers`;
export const feedbackUrl = (queueId) => `${cleanBase}/api/queues/${queueId}/feedback`;
export const deleteQueueUrl = (queueId) => `${cleanBase}/api/queues/${queueId}`;
export const processQueueEndpoint = processQueueUrl;
export const inputFileUrl = (queueId, download = false) =>
  `${cleanBase}/api/queues/${queueId}/input-file${download ? '?download=true' : ''}`;
